<template>
  <div>
    <!-- Overview -->
    <v-slide-group
      v-if="group === 'overview'"
      v-model="model"
      class="py-4"
      :class="{'px-0':$vuetify.breakpoint.xs,'px-3':$vuetify.breakpoint.smAndUp}"
      prev-icon="arrow_back_ios"
      next-icon="arrow_forward_ios"
      :show-arrows="$vuetify.breakpoint.xs ? false:true"
    >
      <div
        v-for="(item, index) in list"
        v-bind:key="index"
        :style="$vuetify.breakpoint.xs ? {'width':'320px'}:{'width':'418px'}"
      >
        <ReportCard
          :title="item[`name_${language}`]"
          :desc="item[`intro_${language}`]"
          :item="item"
          :id="item.id"
          :imgname="item.cover_img_path"
          onclick="https://www.cea.or.th/thailand-craft-industry"
        ></ReportCard>
      </div>
    </v-slide-group>

    <!-- Data and Statistic tab (overview page) -->
    <v-slide-group
      v-else-if="group === 'statistic_tab'"
      v-model="model"
      class="py-4"
      :class="{'px-0':$vuetify.breakpoint.xs,'px-3':$vuetify.breakpoint.smAndUp}"
      prev-icon="arrow_back_ios"
      next-icon="arrow_forward_ios"
      :show-arrows="$vuetify.breakpoint.xs ? false:true"
    >
      <div
        v-for="(item, index) in list"
        v-bind:key="index"
        :style="$vuetify.breakpoint.xs ? {'width':'320px'}:{'width':'418px'}"
      >
        <ReportCard
          :title="item[`name_${language}`]"
          :desc="item[`intro_${language}`]"
          :item="item"
          :id="item.id"
          :imgname="item.cover_img_path"
          onclick="https://www.cea.or.th/thailand-craft-industry"
        ></ReportCard>
      </div>
    </v-slide-group>

    <!-- Industries -->
    <v-slide-group
      v-else-if="group === 'industries'"
      v-model="model"
      class="py-4"
      :class="{'px-0':$vuetify.breakpoint.xs,'px-3':$vuetify.breakpoint.smAndUp}"
      prev-icon="arrow_back_ios"
      next-icon="arrow_forward_ios"
      :show-arrows="$vuetify.breakpoint.xs ? false:true"
    >
      <div
        v-for="(item, index) in list"
        v-bind:key="index"
        :style="$vuetify.breakpoint.xs ? {'width':'320px'}:{'width':'418px'}"
      >
        <ReportCard
          :title="item[`name_${language}`]"
          :desc="item[`intro_${language}`]"
          :item="item"
          :id="item.id"
          :imgname="item.cover_img_path"
          onclick="https://www.cea.or.th/thailand-craft-industry"
        ></ReportCard>
      </div>
    </v-slide-group>

    <!-- Research & Report -->
    <v-layout column mb-12 v-else-if="group === 'report'">
      <v-layout
              justify-start
              row
              wrap
              mx-3
              mb-7
              :class="{'justify-left':$vuetify.breakpoint.mdAndDown}"
      >
        <template v-if="list.length>0">
          <v-flex xs12 sm6 md4 mb-7 v-for="(item, index) in list" v-bind:key="index" >
            <template v-if="language=='en' && item['intro_en'] == null">
              <ReportCard
                  :title="item"
                  :desc="item[`intro_th`]"
                  :id="item.id"
                  :item="item"
                  :imgname="item.cover_img_path"
              ></ReportCard>
            </template>
            <template v-else-if="language=='th' && item['intro_th'] == null">
              <ReportCard
                  :title="item"
                  :desc="item[`intro_en`]"
                  :id="item.id"
                  :item="item"
                  :imgname="item.cover_img_path"
              ></ReportCard>
            </template>
            <template v-else>
              <ReportCard
                  :title="item"
                  :desc="item[`intro_${language}`]"
                  :id="item.id"
                  :item="item"
                  :imgname="item.cover_img_path"
              ></ReportCard>
            </template>
<!--            <ReportCard-->
<!--                :title="item"-->
<!--                :desc="item[`intro_${language}`]"-->
<!--                :id="item.id"-->
<!--                :item="item"-->
<!--                :imgname="item.cover_img_path"-->
<!--            ></ReportCard>-->

          </v-flex>
        </template>
        <template v-else>
          <v-flex mb-7>No article found.</v-flex>
        </template>
      </v-layout>

      <!-- <v-pagination></v-pagination>-->

      <!--
      <span v-else class="txtTopic" style="color: #FF5100">... {{$t('seeMore')}} ...</span>
      -->
    </v-layout>
  </div>
</template>

<script>
import ReportCard from "../components/ReportCard";
import { mapActions, mapState } from "vuex";
import { domain } from '../services/Constants';

export default {
  name: "ReportGroup",
  components: {
    ReportCard
  },
  computed: {
    ...mapState({
      language: state => state.locale.language
    })
  },
  props: ["group", "list"],
  data: () => ({
    model: true,
    reportPagination: 1,
    busy: false,
    http: domain
  }),
  created() {},
  methods: {}
};
</script>

<style scoped>
</style>
